import { SelectionChangedEvent } from "ag-grid-community";
import { StdProposalTariffItemTierEntity } from "domain/entity/StandardProposal/StdProposalTariffItemTierEntity";
import { INITIAL_STANDARD_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF } from "presentation/constant/StandardProposal/StandardProposalTariffItemTierColumnDefinition";
import { INITIAL_STD_PROPOSAL_COPY_TO_PROPOSAL_PREVIEW_COL_DEF } from "presentation/constant/StandardProposal/StdProposalCopyToProposalPreviewColumnDefinition";
import { useStandardProposalVM } from "presentation/hook/StandardProposal/useStandardProposalVM";
import { useStandardProposalTracked } from "presentation/store/StandardProposal/StandardProposalProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const CopyPreviewPanel: React.FC = () => {

    const [standardProposalState] = useStandardProposalTracked();
    const standardProposalVM = useStandardProposalVM();
    const { copyToEditNewProposal, isCopyToNewProposal, copyToProposalNo, selectCopyToNewTariff, isCopyEditTier } = standardProposalState;


    const handClose = useCallback(() => {
        standardProposalVM.onClosePreviewPanel();
    }, [standardProposalVM]);

    const handleNewTariffPreviceSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        standardProposalVM.onShowTariffItemTierPanel(selectedRows, isCopyEditTier);
    }, [standardProposalVM, isCopyEditTier]);

    const handleNewCopyTierRateSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        standardProposalVM.onShowTariffItemTierRatePanel(selectedRows);
    }, [standardProposalVM]);

    const handleCopyTierRateDoubleClick = useCallback((entity: StdProposalTariffItemTierEntity) => {
        standardProposalVM.onDoubleClickTariffItemTierRatePanel(entity);
    }, [standardProposalVM])


    const memoCopyToNewProposalTariffTable = useMemo(() => {

        return (
            <NbisTable
                headerLabel={"Proposal Tariff List"}
                id='standard-proposal-preview-tier-table'
                isNewColumnSetting={true}
                columns={INITIAL_STD_PROPOSAL_COPY_TO_PROPOSAL_PREVIEW_COL_DEF}
                data={((isCopyToNewProposal ? copyToEditNewProposal.copyToNewTariff?.slice() : copyToProposalNo.copyToNewTariff?.slice()) ?? [])}
                showPaginator={false}
                editable={false}
                showUploadIcon={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"single"}
                isRowHighligted={true}
                handleSelectionChanged={handleNewTariffPreviceSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 600px)"
            />
        );
    }, [copyToEditNewProposal.copyToNewTariff, copyToProposalNo.copyToNewTariff, handleNewTariffPreviceSelectionChange, isCopyToNewProposal])

    const memoCopyToNewProposalTierTable = useMemo(() => {

        return (
            <NbisTable
                headerLabel={"Tier List"}
                id='standard-proposal-preview-tier-table'
                isNewColumnSetting={true}
                columns={INITIAL_STANDARD_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF}
                data={(selectCopyToNewTariff.copyToNewTariffItemTierList?.slice() ?? [])}
                showPaginator={false}
                editable={false}
                showUploadIcon={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"single"}
                isRowHighligted={true}
                gridHeight="customHeight"
                onRowDoubleClick={(e: any, entity: StdProposalTariffItemTierEntity) => handleCopyTierRateDoubleClick(entity)}
                handleSelectionChanged={handleNewCopyTierRateSelectionChange}
                customHeight="calc(100vh - 630px)"
            />
        );
    }, [handleCopyTierRateDoubleClick, handleNewCopyTierRateSelectionChange, selectCopyToNewTariff.copyToNewTariffItemTierList])

    return <>
        <div className={'flex-row'} style={{ overflow: "visible", zIndex: "100" }}>
            <div className={'flex-row-item flex-row-item-full-width'} >
                <Sidebarheader>
                    <SidebarTitle></SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>

            <div style={{ height: '40%' }}>
                <TableWrapper> {memoCopyToNewProposalTariffTable} </TableWrapper>
            </div>
            <div style={{ height: '50%' }}>
                <TableWrapper> {memoCopyToNewProposalTierTable} </TableWrapper>
            </div>
        </div>
    </>;
}

export default memo(CopyPreviewPanel);
